<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent dialog-toolbar">
    <mat-toolbar-row class="dialog-toolbar-row">
      <span class="title dialog-title">
        {{'parishOrganization.title' | translate}}
        @if (user()?.frontUser) {
          - {{user()?.frontUser?.lastName}} {{user()?.frontUser?.firstName}}
        }
      </span>
      <button mat-button class="mat-icon-button"
              (click)="close()"
              aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="dialog-content">
    <div class="parish-orgs-list">
      @for (item of parishOrgs(); track item.id || $index; let index = $index) {
        <div class="parish-org-item">
          <mat-form-field appearance="fill" class="org-field">
            <mat-label>{{'parishOrganization.selected_organization' | translate}}</mat-label>
            <mat-select [value]="item.parishOrganizationId" (selectionChange)="onParishChange(item, $event.value)">
              @for (parish of parishOrganizations(); track parish.id || $index) {
                <mat-option [value]="parish.id">
                  {{parish.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill" class="activity-field">
            <mat-label>{{'parishOrganization.selected_activity' | translate}}</mat-label>
            <mat-select [value]="item.activityId" (selectionChange)="onActivityChange(item, $event.value)">
              @for (activity of activities(); track activity.id || $index) {
                <mat-option [value]="activity.id">
                  {{activity.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <button mat-icon-button color="warn" (click)="removeParishOrg(index)" aria-label="Remove item">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      } @empty {
        <div class="no-data">
          {{'no_data' | translate}}
        </div>
      }
    </div>

    <div class="add-action-wrapper">
      <button mat-raised-button color="accent" (click)="addParishOrg()">
        <mat-icon class="add-org-icon">add</mat-icon>
        {{'add' | translate}}
      </button>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-raised-button class="mat-accent" (click)="close()">
      {{'main.cancel' | translate}}
    </button>
    <button mat-raised-button class="mat-accent" (click)="save()">
      {{'main.save' | translate}}
    </button>
  </div>
</div>
